
import React from 'react';
import WaterConsumptionAreaChart from './WaterConsumptionAreaChart';

const WaterConsumptionTab = () => {
  return (
    <div className="space-y-6">
      <WaterConsumptionAreaChart />
    </div>
  );
};

export default WaterConsumptionTab;
